
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[shortcode]",
      function () {
        return require("private-next-pages/partners/[shortcode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[shortcode]"])
      });
    }
  